// Claude Code style status texts (without dots)
const STATUS_TEXTS = [
  "Splunking",
  "Generating",
  "Analyzing",
  "Processing",
  "Exploring",
  "Investigating",
  "Searching",
  "Parsing",
  "Evaluating",
  "Examining",
  "Scanning",
  "Indexing",
  "Traversing",
  "Querying",
  "Inspecting",
  "Discovering",
  "Mapping",
  "Filtering",
  "Compiling",
  "Resolving",
  "Pulsing",
];

export const getRandomStatusText = () => {
  return STATUS_TEXTS[Math.floor(Math.random() * STATUS_TEXTS.length)];
};
